import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=7dd83984&scoped=true&"
import script from "./VDatePicker.vue?vue&type=script&lang=ts&"
export * from "./VDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./VDatePicker.vue?vue&type=style&index=0&id=7dd83984&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd83984",
  null
  
)

export default component.exports